// src/js/index.ts
import { createContext, useContext, useEffect } from "react";
var Context = createContext(null);
var SocketProvider = Context.Provider;
var useSocketClient = () => useContext(Context);
function useSocket(event, handler, dependencies = []) {
  const socket = useContext(Context);
  useEffect(() => {
    if (event !== null) {
      socket == null ? void 0 : socket.on(event, handler);
      return () => {
        socket == null ? void 0 : socket.off(event, handler);
      };
    }
  }, [event, ...dependencies]);
}
export {
  SocketProvider,
  useSocket as default,
  useSocketClient
};
